<template>
  <div class="editor">
    <CloseButton @close="$emit('call-editor', 'close')" />
    <div class="-header">
      <div class="--title">
        <span>{{ mode === "edit" ? "Edit" : "Add" }} Assessment</span>
      </div>
      <span class="--subtitle">{{ mode === "edit" ? "แก้ไข" : "เพิ่ม" }} หลักเกณฑ์การประเมิน</span>
    </div>
    <div class="-body">
      <Block no-border>
        <InputBox
          label="คะแนนเต็ม"
          :edata="newAssessment['score']"
          prop="score"
          @input="handleInput"
          data-type="number"
        />
      </Block>
      <Block no-border>
        <SelectBox
          label="หลักเกณฑ์"
          prop="assessmentId"
          :edata="newAssessment['assessmentId']"
          @input="handleInput"
          :options="assessmentOptions"
        />
      </Block>
      <!-- <Block no-border>
        <InputBox
          label="ชื่อย่อ"
          :edata="newAssessment['nameLocal']"
          prop="nameLocal"
          @input="handleInput"
        />
      </Block> -->
      <BlockGroup inline>
        <Block no-border>
          <InputBox
            label="เปอร์เซนต์"
            :edata="newAssessment['percent']"
            prop="percent"
            @input="handleInput"
            data-type="number"
          />
        </Block>
        <Block no-border>
          <InputBox
            label="ลำดับ"
            :edata="newAssessment['seq']"
            prop="seq"
            @input="handleInput"
            data-type="number"
          />
        </Block>
      </BlockGroup>
      <div class="--controllers">
        <vs-button @click="saveData">Save</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import Block from "@/components/common-ui/block/index.vue";
import BlockGroup from "@/components/common-ui/block-group/index.vue";
import InputBox from "@/components/common-ui/forms/input-box/index.vue";
import SelectBox from "@/components/common-ui/forms/select-box/index.vue";
import {
  addCourseOutlineAssessment,
  updateCourseOutlineAssessment
} from "@/services/api/course-outline";

export default {
  props: {
    mode: String,
    edata: Object,
  },
  components: {
    CloseButton: () => import("./editor-close"),
    Block,
    BlockGroup,
    InputBox,
    SelectBox
  },
  data() {
    return {
      assessmentOptions: [{ id: "", title: "" }],
      newAssessment: {
        id: "",
        courseOutlineId: "",
        nameLocal: "",
        assessmentId: "",
        seq: 0,
        percent: 0,
        score: 0
      }
    }
  },
  methods: {
    getAssessmentOptions() {
      return this.$store.state.MasterData.assessments;
    },
    transformAssessmentOptions(list) {
      if (list && Array.isArray(list)) {
        return list.map(item => {
          return { id: item.id, title: item.nameLocal };
        })
      }
      return [{ id: "", title: "No assessment options"}];
    },
    loadData() {
      this.newAssessment = { ...this.newAssessment, ...this.edata };
      
      if (this.assessmentOptions.length < 2) {
        this.assessmentOptions = this.transformAssessmentOptions(this.getAssessmentOptions());
      }
      // this.newAssessment.assessmentId = this.edata.assessment.id;
    },
    async saveData() {
      let res = null;
      if (this.mode === "edit") {
        res = await updateCourseOutlineAssessment(this.newAssessment);
      } else {
        res = await addCourseOutlineAssessment(this.newAssessment);
      }
      if (res) {
        this.$emit("call-editor", "close");
      }
    },
    handleInput({ prop, data }) {
      this.newAssessment[prop] = data;
      this.$forceUpdate();
    }
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.loadData();
  },
}
</script>

<style lang="scss" scoped>
@import "common-scoped";

.editor {
  display: flex;
  flex-direction: column;

  & .-header {
    width: 100%;
    display: block;
    margin-bottom: 20px;

    & .--title {
      font-size: 2rem;
      color: #6f66b9;
      padding-bottom: 1rem;
      width: 100%;
      height: 3rem;
      border-bottom: 2px solid #e8e8e8;
    }
    & .--subtitle {
      margin-top: 1rem;
      font-size: 1rem;
    }
  }

  & .-body {
    display: flex;
    width: 80%;
    flex-direction: column;

    & .--controllers {
      margin-top: 20px;
    }
  }
}
</style>